package com.fireavert.events.shared.data_models.models

enum class EventLinkedActionType {
    StoveShutoff,
    TextAlert,
    StoveReset
}